<template>
<div id="pages-about-me">

	<div class="fill">
		<div class="d-flex flex-column justify-content-center h-100 text-center">
			<h1>
				<img src="../assets/logo.png" height="60rem" style="vertical-align: bottom;">
				Cheng Vue
			</h1>
			<h2 class="text-muted text-uppercase small">
				Aspiring Programmer
			</h2>
			<p class="text-muted font-weight-bold small">
				<a href="#about-me" v-on:click="scrollToAboutMe">About Me</a> 
				<span class="font-weight-light"> | </span> 
				<router-link to="/portfolio">Portfolio</router-link>
			</p>
		</div>
	</div>

	<div id="about-me"></div>
	<div class="bg-primary text-white text-center p-5">
		<h3 class="mb-2 text-center">Who am I?</h3>
		<p class="px-sm-2 px-md-5 mx-sm-0 mx-md-5 mb-0 font-weight-light">I'm a self-taught, self-driven programmer. My journey began as a graphic designer, 
		but not long after was exposed to web development. I've come to enjoy the challenges 
		and creative problem solving through programming.</p>
	</div>

	<div class="container pt-5 pb-5">
		<div class="row justify-content-center">
			<div class="col-sm-12 col-md-6 pl-3 pr-3 text-center">
				<h3 class="mb-2 text-center">What I'm doing?</h3>
				<p class="px-sm-2 px-md-5 mb-md-0 mb-sm-4 font-weight-light">
					Currently I'm employed with e.Republic and mainly focus my programming efforts on maintaining
					and building new features for the GovernmentNavigator tool. Visit my 
					<router-link to="/portfolio" class="font-weight-bold">portfolio</router-link> for
					project responsibilities.
				</p>
			</div>
			<div class="col-sm-12 col-md-6 pl-3 pr-3 text-center">
				<h3 class="mb-2 text-center">What have I been learning?</h3>
				<p class="px-sm-2 px-md-5 mb-0 font-weight-light">
					I currently spend my spare time researching into machine learning and mobile app 
					development. Branching my knowlegend from React Native, Ionic, Flutter, TensorFlow, and to any other
					code library I can learn from.
				</p>
			</div>
		</div>
	</div>

	<div class="bg-secondary">
		<div class="container pt-5 pb-5">
			<div class="row justify-content-center">
				<div class="card col-12 col-md-4 px-3 pr-md-5 text-center">
					<h3 class="pt-3">Front-end</h3>
					<p class="font-weight-light">
						I'm utilize my design background while translating design to code.
					</p>
					<h4 class="text-primary">Languages</h4>
					<p class="font-weight-light">
						<ul class="list-unstyled">
							<li>CSS / SASS / LESS</li>
							<li>HTML</li>
							<li>JavaScript ES5 / ES6</li>
							<li>JSON</li>
							<li>XML</li>
						</ul>
					</p>

					<h4 class="text-primary">Tools/Libraries</h4>
					<p class="font-weight-light">
						<ul class="list-unstyled">
							<li>Angular / AngularJs</li>
							<li>AJAX</li>
							<li>Bootstrap 3/4</li>
							<li>jQuery / jQuery UI</li>
							<li>NPM</li>
							<li>VueJs</li>
						</ul>
					</p>
				</div>
				<div class="card col-12 col-md-4 pl-3 pr-3 text-center center-card">
					<h3 class="text-center pt-3">Full-stack</h3>
					<p class="font-weight-light">
						Although I have worked in the ASP.NET stack, A large majority of my
						experience has been within the LAMP/LEMP stack.
					</p>
					<h4 class="text-primary">Environment Tools</h4>
					<p class="font-weight-light">
						<ul class="list-unstyled mb-0">
							<li>AWS</li>
							<li>Linux / Ubuntu / RedHat</li>
							<li>Vagrant</li>
							<li>VirtualBox</li>
						</ul>
					</p>
					<hr>
					<p class="font-weight-light">
						I've also have experience utilizing running commands within the shell environment a:
					</p>
					<h4 class="text-primary">Shell Tools</h4>
					<p class="font-weight-light">
						<ul class="list-unstyled">
							<li>CRONTAB</li>
							<li>GIT</li>
							<li>SSH</li>
							<li>VI / VIM</li>
						</ul>
					</p>
				</div>
				<div class="card col-12 col-md-4 pl-md-5 px-3 text-center">
					<h3 class="text-center pt-3">Back-end</h3>
					<p class="font-weight-light">
						I've worked with everything from database design, to business logic implementations.
					</p>
					<h4 class="text-primary">Languages</h4>
					<p class="font-weight-light">
						<ul class="list-unstyled">
							<li>Javascript / NodeJS</li>
							<li>PHP</li>
							<li>SQL / MySQL</li>
						</ul>
					</p>

					<h4 class="text-primary">Tools/Libraries</h4>
					<p class="font-weight-light">
						<ul class="list-unstyled">
							<li>Composer</li>
							<li>Custom MVC Frameworks</li>
							<li>ElasticSearch</li>
							<li>Laravel</li>
							<li>OOP</li>
							<li>PHPUnit</li>
							<li>Zend</li>
						</ul>
					</p>
				</div>
			</div>
		</div>
	</div>

	<div class="bg-primary text-white text-center p-5 text-uppercase">
			<a href="https://www.linkedin.com/in/cheng-vue-5058aa8a" target="_blank" title="linkedin">
				<img src="../assets/In-White-128px-R.png" height="20rem">
			</a>
			| <router-link to="/" class="text-white">Cheng Vue</router-link> 
			- <router-link to="/portfolio" class="text-white">Portfolio</router-link> 
	</div>
</div>
</template>

<script>
export default {
	name: 'pages-about-me',
	methods: {
		scrollToAboutMe(e) {
			console.log(e);
		}
	}

}

</script>

<style>
.fill {
	width: 100%;
	height: 100%;
	min-height: 100%;
	display: block;
}

.center-card {
	margin: -1rem -2rem;
	z-index: 2;
	position: relative
}

#pages-about-me { 
	min-height: 100%;
	height: 100%;
}
</style>
